
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/streams",
      function () {
        return require("private-next-pages/streams.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/streams"])
      });
    }
  